import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { VerificationCustomerService } from '@api/verification-customer.service';
import { verificationCustomerModel } from '@shared/model/verification-customer.model';
import jalaliMoment = require('jalali-moment');
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-verification-customer',
  templateUrl: './verification-customer.component.html',
  styleUrls: ['./verification-customer.component.scss']
})
export class VerificationCustomerComponent implements OnInit {
  public destroy$ = new Subject<void>();
  verificationCustomerList: any
  startPage = 1;
  pageSize= 100;
  totalPage = 0;
  constructor(
  private verificationCustomerService: VerificationCustomerService

  ) { }

  ngOnInit(): void {
    this.verificationCustomerService.getVerificationCustomerList(this.startPage , this.pageSize).pipe(takeUntil(this.destroy$ )).subscribe(
      (res) =>{
        this.verificationCustomerList= res;
        this.verificationCustomerList.forEach((element): any => {
          element.requestDate = jalaliMoment( element.requestDate).format('jYYYY/jMM/jDD hh:mm');
        });
      }
    )
  }

  public getServerData(event?: PageEvent) {
    this.pageSize = event.pageSize
    this.verificationCustomerService.getVerificationCustomerList( (event.pageIndex) + 1 , this.pageSize ).pipe(takeUntil(this.destroy$ )).subscribe(
      (res) =>{
        this.verificationCustomerList = res;
        this.verificationCustomerList.forEach((element): any => {
          element.requestDate = jalaliMoment( element.requestDate).format('jYYYY/jMM/jDD hh:mm');
        });
  }
    )}

}
